import { IdBased } from '../shared/id-based.model';

export class TaskDescriptionAcknowledgement implements IdBased {
  public id: string;
  public projectTaskDescriptionId: string;
  public createdAt: Date | undefined;
  /** Task participant id of the user who acknowledged. */
  public createdById: string;
  public updatedAt: Date | undefined;
  /** User id of the participant who acknowledged. */
  public userId: string;
  public acceptedAt: Date | undefined;

  public constructor(value: Partial<TaskDescriptionAcknowledgement>) {
    Object.assign(this, value);
  }
}
